<template>
    <draggable
            v-model="tabs"
            class="draggable-list-container"
            :move="checkMove"
    >
        <draggable-filter-tab
                v-for="tab in tabs"
                :key="tab.id"
                :draggable-tab="tab"
                @onChangeTab="onChangeTab"
        />
    </draggable>
</template>

<script>
    import draggable from 'vuedraggable'
    import {mapActions, mapGetters} from "vuex"
    import DraggableFilterTab from "./DraggableFilterTab"
    import {purchasesPath} from "@/router/purchases"

    export default {
        name: "DraggableFilterTabsList",
        components: {
            DraggableFilterTab,
            draggable,
        },
        data() {
            return {

            }
        },
        computed: {
            ...mapGetters('filterTabs', ['filterTabs']),
            ...mapGetters('profile', ['profileId']),
            tabs: {
                get() {
                    return this.filterTabs.filter((tab) => this.filterHidden(tab) && this.hideFavorites(tab) && this.filterTags(tab))
                },
                set(newTabs) {
                    const hiddenExists = newTabs.some((t) => t.filterType === "HIDDEN");
                    const hiddenTab = [this.filterTabs.find((t) => !hiddenExists && t.filterType === "HIDDEN")].filter(Boolean);
                    const filteredTabs = newTabs.filter((tab) => tab.filterType !== "TAG");
                    this.updateAllFilterTabs({newFilterTabs: [...hiddenTab,...filteredTabs], profileId: this.profileId})
                }
            },
        },
        methods: {
            ...mapActions('filterTabs', ['updateAllFilterTabs']),
            onChangeTab(tab) {
                this.$emit('onChangeTab', tab)
            },
            hideFavorites(tab) {
                return tab.filterType !== 'FAVORITES'
            },
            filterHidden(tab) {
                return tab.filterType !== 'HIDDEN' || this.$route.path === `${purchasesPath}/${tab.id}`
            },
            filterTags(tab) {
                return tab.filterType !== 'TAG' || this.$route.path === `${purchasesPath}/${tab.id}`
            },
            checkMove(evt) {
                const dragged = evt.draggedContext.element
                const newIndex = evt.relatedContext.index

                const isntMovableTab = ["TAG", "HIDDEN", "ALL"].includes(dragged.filterType)
                const minMovableIndex = this.tabs.findIndex(tab => !["TAG", "HIDDEN", "ALL"].includes(tab.filterType))
                const cantMoveToIndex = newIndex < minMovableIndex
                

                if (isntMovableTab || cantMoveToIndex) {
                    return false
                }
            
                return true
            }           
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/variables.less';

    .draggable-list-container {
        overflow-y: auto;
        position: absolute;
        background-color: white;
        top: 100%;
        right: 0;
        width: 306px;
        max-height: 506px;
        padding: 8px;
        box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.3);
        border-radius: 5px;
        z-index: 100;
    }

    &::-webkit-scrollbar {
        border-radius: @br;
        width: 8px;
        background-color: #ffffff;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: @br;
        width: 8px;
        background-color: fade(#000000, 24%);
        &:hover {
            background-color: fade(#000000, 30%);
        }
    }
</style>